<span [ngClass]="class">{{text}}</span>
